import React from "react";
import TagIcon from "../../../Images/Startup-Spotlight/TagIcon.png";
import FirstPlaceIcon from "../../../Images/Startup-Spotlight/firstPlace.png";
import SecondPlaceIcon from "../../../Images/Startup-Spotlight/secondPlace.png";
import ThirdPlaceIcon from "../../../Images/Startup-Spotlight/thirdPlace.png";
import "./ProductCard.scss";

const ProductCard = ({
	product,
	onClick,
	onUpvote,
	onDownvote,
	isTopProduct = false,
	topRank = null,
	ref = null,
}) => {
	// Get medal icon based on product position
	const getMedalIcon = (position) => {
		switch (position) {
			case 0:
				return FirstPlaceIcon;
			case 1:
				return SecondPlaceIcon;
			case 2:
				return ThirdPlaceIcon;
			default:
				return null;
		}
	};

	return (
		<div
			ref={ref}
			className="sp-product-card"
			onClick={() => onClick(product._id)}
		>
			{isTopProduct && topRank !== null && topRank < 3 && (
				<img
					src={getMedalIcon(topRank)}
					alt={`Top ${topRank + 1}`}
					className="medal-badge"
				/>
			)}

			<div className="product-header">
				<div className="product-logo">
					<img src={product.logo || "/placeholder.svg"} alt={product.title} />
				</div>
				<div className="product-description">
					<div className="product-title">
						<h3>{product.title}</h3>
					</div>
					<p className="product-description">
						{product.tagline && product.tagline.length > 80
							? `${product.tagline.substring(0, 80)}...`
							: product.tagline}
					</p>
					<div className="product-tags">
						{/* <img className="tag-icon" src={TagIcon} alt="" /> */}
						{product.tags &&
							product.tags.slice(0, 3).map((tag, index) => (
								<span className="tag" key={index}>
									{tag}
								</span>
							))}
						{product.industry && (
							<span className="tag industry">{product.industry}</span>
						)}
					</div>
				</div>
			</div>

			<div className="product-metrics">
				<button
					className="upvote-button"
					// onClick={(e) => {
					// 	e.stopPropagation();
					// 	onUpvote(e, product._id);
					// }}
					title="Upvote"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
					</svg>
					<span>{product.upvotes ? product.upvotes.length : 0}</span>
				</button>
				<button
					className="downvote-button"
					// onClick={(e) => {
					// 	e.stopPropagation();
					// 	onDownvote(e, product._id);
					// }}
					title="Downvote"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3"></path>
					</svg>
					<span>{product.downvotes ? product.downvotes.length : 0}</span>
				</button>
				<button className="comment-button">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
					</svg>
					<span className="comment-count">
						{product.comments
							? product.firstComment
								? product.comments.length + 1
								: product.comments.length
							: 0}
					</span>
				</button>
			</div>
		</div>
	);
};

export default ProductCard;
